var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_radial_687_2596)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3049 15.4485V12.7474C17.3049 12.3937 17.1793 12.0894 16.9282 11.8347C16.677 11.58 16.3728 11.4527 16.0154 11.4527C15.658 11.4527 15.352 11.58 15.0972 11.8347C14.8425 12.0894 14.7151 12.3937 14.7151 12.7474V15.9486C14.7151 16.141 14.7497 16.321 14.8189 16.4886C14.8881 16.6561 14.9919 16.8069 15.1303 16.9409L17.8179 19.6282C18.0734 19.8727 18.3741 19.9987 18.7202 20.0063C19.0662 20.0138 19.3712 19.8878 19.6351 19.6282C19.8839 19.3838 20.012 19.0799 20.0196 18.7165C20.0272 18.3531 19.9045 18.0449 19.6514 17.7919L17.3049 15.4485ZM16.0001 26.0001C14.6158 26.0001 13.3134 25.7398 12.0929 25.2192C10.8724 24.6987 9.81195 23.9882 8.91152 23.0879C8.01108 22.1875 7.30056 21.1272 6.77997 19.9068C6.25934 18.6864 5.99902 17.3842 5.99902 16C5.99902 14.612 6.25977 13.3082 6.78126 12.0887C7.30277 10.8692 8.0152 9.80814 8.91855 8.90549C9.8219 8.00286 10.8824 7.29295 12.0999 6.77577C13.3175 6.25859 14.6176 6 16.0001 6C17.3881 6 18.6921 6.25851 19.912 6.77554C21.1319 7.29258 22.1932 8.0024 23.0959 8.90499C23.9986 9.80759 24.7085 10.869 25.2256 12.0891C25.7426 13.3093 26.0012 14.6136 26.0012 16.0019C26.0012 17.3903 25.7426 18.6914 25.2253 19.9052C24.7081 21.119 23.9981 22.1776 23.0954 23.0808C22.1926 23.9841 21.1315 24.6964 19.9118 25.2179C18.6922 25.7393 17.3883 26.0001 16.0001 26.0001Z",
    fill: "url(#paint1_linear_687_2596)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_687_2596",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.781 16) rotate(42.4343) scale(20.6205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4FFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_687_2596",
    x1: 5.99902,
    y1: 16.0002,
    x2: 26.001,
    y2: 16.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FBB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#269974"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClock);
export default __webpack_public_path__ + "static/media/time-clock.542237645ddf7102b49897d9ed4112ee.svg";
export { ForwardRef as ReactComponent };